// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-error {
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: 16px;
}
.chartkit-error__title {
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 12px;
}
.chartkit-error__actions {
  margin-bottom: 12px;
}
.chartkit-error__action:not(:first-child) {
  margin-left: 10px;
}
.chartkit-error__request-id {
  color: #999999;
  letter-spacing: 1px;
  font-size: 11px;
}
.chartkit-error__more {
  font-family: "SF Mono", "Menlo", "Monaco", "Consolas", "Ubuntu Mono", "Liberation Mono", "DejaVu Sans Mono", "Courier New", "Courier", monospace;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  padding: 10px;
  font-size: 13px;
  border-radius: 4px;
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/Error/Error.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAFJ;AAII;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AAFR;AAKI;EACI,mBAAA;AAHR;AAOQ;EACI,iBAAA;AALZ;AASI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;AAPR;AAUI;EACI,gJAlCc;EAmCd,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AARR","sourcesContent":[".chartkit-error {\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n}\n.chartkit-error__title {\n  font-size: 13px;\n  line-height: 16px;\n  margin-bottom: 12px;\n}\n.chartkit-error__actions {\n  margin-bottom: 12px;\n}\n.chartkit-error__action:not(:first-child) {\n  margin-left: 10px;\n}\n.chartkit-error__request-id {\n  color: #999999;\n  letter-spacing: 1px;\n  font-size: 11px;\n}\n.chartkit-error__more {\n  font-family: \"SF Mono\", \"Menlo\", \"Monaco\", \"Consolas\", \"Ubuntu Mono\", \"Liberation Mono\", \"DejaVu Sans Mono\", \"Courier New\", \"Courier\", monospace;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  padding: 10px;\n  font-size: 13px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
